/** Sanction-order deductions. Additional Royalty, SMET, Penalty in Deduction, Restoration, Stamp Duty, and DMFT have Add Challan. Security Deposit is listing only. */
export const DEDUCTION_LISTINGS = [
    {
        path: '/additional-royalty',
        title: 'Additional Royalty',
        apiFlag: 'additional_royalty',
        amountField: 'additional_royalty_amount',
        amountHeader: ['Additional Royalty', 'Amount'],
        addPath: '/add-additional-royalty',
        holdingChallan: true,
    },
    {
        path: '/smet',
        title: 'SMET',
        apiFlag: 'smet',
        amountField: 'smet_amount',
        amountHeader: ['SMET', 'Amount'],
        addPath: '/add-smet',
        holdingChallan: true,
    },
    {
        path: '/penalty-in-deduction',
        title: 'Penalty in Deduction',
        apiFlag: 'penalty_in_deduction',
        amountField: 'penalty_in_deduction_amount',
        amountHeader: ['Penalty in Deduction', 'Amount'],
        addPath: '/add-penalty-in-deduction',
        holdingChallan: true,
    },
    {
        path: '/restoration',
        title: 'Restoration',
        apiFlag: 'restoration',
        amountField: 'restoration_amount',
        amountHeader: ['Restoration', 'Amount'],
        addPath: '/add-restoration',
        holdingChallan: true,
    },
    {
        path: '/stamp-duty',
        title: 'Stamp Duty',
        apiFlag: 'stamp_duty',
        amountField: 'stamp_duty_amount',
        amountHeader: ['Stamp Duty', 'Amount'],
        addPath: '/add-stamp-duty',
        holdingChallan: true,
    },
    {
        path: '/dmft',
        title: 'DMFT',
        apiFlag: 'dmft',
        amountField: 'dmft_amount',
        amountHeader: ['DMFT', 'Amount'],
        addPath: '/add-dmft',
        holdingChallan: true,
    },
    {
        path: '/security-deposit',
        title: 'Security Deposit',
        apiFlag: 'security_deposit',
        amountField: 'security_deposit_amount',
        amountHeader: ['Security Deposit', 'Amount'],
    },
];
